<template>
  <div id="refundTable">
    <el-row class="padding-bottom-row">
      <el-col :span="2">
        <div class="content-label">退款明细</div>
      </el-col>
      <el-col :span="22">
        <el-table :data="tableData" border>
          <el-table-column label="流水类型">
            <template v-slot="scope">
              <div v-if="scope.row.editAble">
                <el-select v-model="scope.row.direction" size="small">
                  <el-option
                    v-for="item in directionOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
              <div v-else>
                {{ scope.row.direction == 1 ? "收入" : "支出" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="对方账户名称">
            <template v-slot="scope">
              <div v-if="scope.row.editAble">
                <el-input v-model="scope.row.fromAccountName"></el-input>
              </div>
              <div v-else>
                {{
                  scope.row.direction == 1
                    ? scope.row.fromAccountName
                    : scope.row.toAccountName
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="对方账户账号">
            <template v-slot="scope">
              <div v-if="scope.row.editAble">
                <el-input v-model="scope.row.fromAccountNo"></el-input>
              </div>
              <div v-else>
                {{
                  scope.row.direction == 1
                    ? scope.row.fromAccountNo
                    : scope.row.toAccountNo
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="对方账户开户机构">
            <template v-slot="scope">
              <div v-if="scope.row.editAble">
                <el-input v-model="scope.row.fromAccountOpenBank"></el-input>
              </div>
              <div v-else>
                {{
                  scope.row.direction == 1
                    ? scope.row.fromAccountOpenBank
                    : scope.row.toAccountOpenBank
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="我方账户名称">
            <template v-slot="scope">
              <div v-if="scope.row.editAble">
                <el-input v-model="scope.row.toAccountName"></el-input>
              </div>
              <div v-else>
                {{
                  scope.row.direction == 1
                    ? scope.row.toAccountName
                    : scope.row.fromAccountName
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="我方账户开户机构">
            <template v-slot="scope">
              <div v-if="scope.row.editAble">
                <el-input v-model="scope.row.toAccountNo"></el-input>
              </div>
              <div v-else>
                {{
                  scope.row.direction == 1
                    ? scope.row.toAccountNo
                    : scope.row.fromAccountNo
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="金额">
            <template v-slot="scope">
              <div v-if="scope.row.editAble">
                <el-input v-model="scope.row.toAccountOpenBank"></el-input>
              </div>
              <div v-else>
                {{
                  scope.row.direction == 1
                    ? scope.row.toAccountOpenBank
                    : scope.row.fromAccountOpenBank
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="金融机构流水证明">
            <template v-slot="scope">
              <div v-if="scope.row.editAble">
                <el-image
                  style="width: 40px; height: 40px"
                  :src="scope.row.attachmentImageUrl"
                  :preview-src-list="[scope.row.attachmentImageUrl]"
                >
                </el-image>
                <el-upload
                  action=""
                  :auto-upload="false"
                  :show-file-list="false"
                  :on-change="(file) => onUploadChange(file, scope.row)"
                >
                  <el-button size="mini" type="text">选择图片</el-button>
                </el-upload>
              </div>
              <div v-else>
                <el-image
                  style="width: 100px; height: 100px"
                  :src="'/api/amazon/image?imageId=' + scope.row.attachmentId"
                  :preview-src-list="[
                    '/api/amazon/image?imageId=' + scope.row.attachmentId,
                  ]"
                >
                </el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot="scope">
              <div v-if="scope.row.editAble">
                <el-button
                  type="text"
                  size="mini"
                  @click="operateSubmit(scope.row)"
                  >确认</el-button
                >
                <el-button type="text" size="mini" @click="operateDelete(scope)"
                  >删除</el-button
                >
              </div>
              <div v-else></div>
            </template>
          </el-table-column>
        </el-table>
        <el-button
          type="text"
          @click="addFund"
          v-if="exchangeRefundInfo.operateType == 1"
          >+新增</el-button
        >
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { compressImage, dataURLtoFile } from "_c/compressImage";
export default {
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      },
    },
    exchangeRefundInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      directionOptions: [
        {
          label: "支出",
          value: -1,
        },
        {
          label: "收入",
          value: 1,
        },
      ],
      paramsInfo: {
        amount: "金额",
        fromAccountName: "对方账户名称",
        toAccountName: "我方账户名称",
        fromAccountNo: "对方账户编号",
        toAccountNo: "我方账户编号",
        fromAccountOpenBank: "对方账户开户机构",
        toAccountOpenBank: "我方账户开户机构",
        picFile: "金融机构流水证明",
      },
    };
  },
  methods: {
    addFund() {
      this.$emit("add-fund");
    },
    onUploadChange(file, row, ...res) {
      console.log(file, row, res);
      compressImage(file.raw, { quality: 0.2 })
        .then((res) => {
          console.log(res);
          row.attachmentImageUrl = res;
          row.picFile = file.raw;
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err ? err : "图片选择失败",
          });
        });
    },
    checkParams(params) {
      for (let prop in this.paramsInfo) {
        if (["", null, undefined].includes(params[prop])) {
          this.$message({
            type: "error",
            message: "请输入" + (this.paramsInfo[prop] || prop),
          });
          return false;
        }
      }
      return true;
    },
    setPostForm(row) {
      let params = new FormData();
      params.append("direction", row.direction);
      params.append("amount", row.amount);
      params.append("picFile", dataURLtoFile(row.attachmentImageUrl));
      params.append(
        "returnLogisticsOrgType",
        this.exchangeRefundInfo.returnLogisticsOrgType
      );
      params.append(
        "returnLogisticsOrderNo",
        this.exchangeRefundInfo.returnLogisticsOrderNo
      );
      params.append("supplierId", this.exchangeRefundInfo.supplierId);
      if (row.direction == 1) {
        params.append("fromAccountName", row.fromAccountName);
        params.append("toAccountName", row.toAccountName);
        params.append("fromAccountNo", row.fromAccountNo);
        params.append("toAccountNo", row.toAccountNo);
        params.append("fromAccountOpenBank", row.fromAccountOpenBank);
        params.append("toAccountOpenBank", row.toAccountOpenBank);
      } else {
        params.append("toAccountName", row.fromAccountName);
        params.append("fromAccountName", row.toAccountName);
        params.append("toAccountNo", row.fromAccountNo);
        params.append("fromAccountNo", row.toAccountNo);
        params.append("toAccountOpenBank", row.fromAccountOpenBank);
        params.append("fromAccountOpenBank", row.toAccountOpenBank);
      }
      return params;
    },
    operateSubmit(row) {
      this.$confirm("是否确认提交?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(1);
          if (!this.checkParams(row)) {
            return;
          }
          console.log(2);
          const params = this.setPostForm(row);
          for (let prop of params) {
            console.log(prop, params.get(prop));
          }
          console.log(3);
          this.$emit("operate-submit", params);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消提交",
          });
        });
    },
    operateDelete(scope) {
      this.$confirm("此操作将删除该条, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.tableData.splice(scope.$index, 1);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style></style>
